<app-headermobile></app-headermobile>
<div class="content">
  <router-outlet></router-outlet>
</div>
<app-footermobile class="footer"></app-footermobile>
